import { abreviaturas } from 'constantes';

export const AuthValidation = (state = {}, action) => {
  switch (action.type) {
    case abreviaturas.TYPE_LOGIN:
      return {
        ...action.payload,
        logged: true,
      };
    case abreviaturas.TYPE_LOGOUT:
      return {
        logged: false,
      };
    default:
      return state;
  }
};
